// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as ProductsContent$Showside from "./ProductsContent.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_CategoryDecoders.bs.js";
function StoreCategoryProductsContent(Props) {
  var layout = Props.layout;
  var categoryId = Props.categoryId;
  var isZoomEnabled = Props.isZoomEnabled;
  var sourceNodeId = Props.sourceNodeId;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var settings = match$1.settings;
  var categories = match$1.categories;
  EntrypointContext$Showside.use(undefined);
  var connection = React.useMemo(function () {
    return {
      TAG: /* StoreCategory */0,
      _0: {
        categoryId: categoryId,
        sortBy: /* Default */0,
        filterBy: undefined,
        count: 100,
        relatedMediaCount: undefined
      }
    };
  }, [categoryId]);
  var category = React.useMemo(function () {
    var category = Belt_Option.flatMap(sourceNodeId, function (sourceNodeId) {
      return Category$Showside.getCategoryById(categories, sourceNodeId);
    });
    if (category !== undefined) {
      var newrecord = Caml_obj.obj_dup(category);
      var categoryType = category.categoryType;
      var tmp;
      if (typeof categoryType === "number" || categoryType.TAG !== /* Standard */1) {
        tmp = category.categoryType;
      } else {
        var categoryType$1 = categoryType._0;
        tmp = {
          TAG: /* Standard */1,
          _0: {
            firstCard: categoryType$1.firstCard,
            externalConnection: connection,
            children: categoryType$1.children,
            loadMoreChildren: categoryType$1.loadMoreChildren,
            totalChildren: categoryType$1.totalChildren,
            link: categoryType$1.link,
            products: categoryType$1.products,
            taggedMedia: categoryType$1.taggedMedia,
            imageHotspots: categoryType$1.imageHotspots,
            imageWidth: categoryType$1.imageWidth,
            imageHeight: categoryType$1.imageHeight
          }
        };
      }
      newrecord.categoryType = tmp;
      newrecord.card = Category$Showside.CategoryCard.setShape(category.card, settings.productCardShape);
      return newrecord;
    }
    var newrecord$1 = Caml_obj.obj_dup(LegacyShowside_CategoryDecoders$ApiTypes.empty);
    newrecord$1.categoryType = {
      TAG: /* Standard */1,
      _0: {
        firstCard: undefined,
        externalConnection: connection,
        children: [],
        loadMoreChildren: undefined,
        totalChildren: 0,
        link: undefined,
        products: [],
        taggedMedia: undefined,
        imageHotspots: undefined,
        imageWidth: undefined,
        imageHeight: undefined
      }
    };
    newrecord$1.card = Category$Showside.CategoryCard.setShape(LegacyShowside_CategoryDecoders$ApiTypes.empty.card, settings.productCardShape);
    return newrecord$1;
  }, [connection, sourceNodeId]);
  return React.createElement(ProductsContent$Showside.make, {
    category: category,
    scrollableContainerRef: scrollableContainerRef,
    layout: layout,
    isZoomEnabled: isZoomEnabled
  });
}
StoreCategoryProductsContent.displayName = "StoreCategoryProductsContent";
var make = React.memo(StoreCategoryProductsContent);
export { make };
/* make Not a pure module */